import { type TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { useUser } from '@/entities/user/model/user.store';
import { type UserType } from '@/entities/user/model/user.types';

import { isDev } from '@/shared/helpers';
import { Languages } from '@/shared/services/localization/types';
import { useAppState } from '@/shared/store/app-store/app-store';

import { REFERRAL_SHARING_MEDIA_ID_EN, REFERRAL_SHARING_MEDIA_ID_RU } from '../constants';
import { MediaType, type ShareData, type ShareVariants } from '../types';
import { generateButtonUrl } from './generate-button-url';

export const useSharingData = (type: ShareVariants, source?: string) => {
  const { t } = useTranslation();
  const { lang } = useAppState();
  const user = useUser();

  if (!user) return;

  if (type === 'REFERRAL' && source) return getReferralSharingData(t, lang, user, source);

  // GAME вариант будет обрабатываться отдельно в use-share.ts
  if (type === 'GAME') return undefined;
};

const getReferralSharingData = (
  t: TFunction,
  lang: Languages,
  user: UserType,
  source: string
): ShareData => {
  const buttonUrl = generateButtonUrl({
    ref: user?.telegramId,
    src: source,
  });

  const mediaType = isDev('replyBot') ? MediaType.PHOTO : MediaType.ANIMATION;

  const mediaId =
    lang === Languages.en ? REFERRAL_SHARING_MEDIA_ID_EN : REFERRAL_SHARING_MEDIA_ID_RU;

  const title = t('I’m playing games on Telegram — join me!');

  const message = [
    t('🎮 200+ games of all genres'),
    t('🏆 Competing with friends'),
    t('💎 Prize giveaways'),
  ].join('\n');

  return {
    telegramId: user.telegramId,
    mediaId,
    mediaType,
    text: `${title}\n\n${message}`,
    buttonText: t('Join Now'),
    buttonUrl,
  };
};
